import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { DropdownDTO } from "../../../types/common/DropdownDTO";

import { IEmployeeState } from "../../../types/employees/employeeInterfaces";

export const initialState: IEmployeeState = {

    employeeDropdown: []

};

export const employeeSlice = createSlice({

    name: 'employee',

    initialState,

    reducers: {

        loadingEmployeeDropdown: (
            state,
            action: PayloadAction<DropdownDTO[]>
        ) => {

            state.employeeDropdown = action.payload;

        },

    }

});

export const {

    loadingEmployeeDropdown

} = employeeSlice.actions;

export default employeeSlice.reducer;